module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/chevronUpVA.ba35a8b3.svg";